import React from 'react';
import { INITIAL_LANDING_PAGE_DATA } from '../constants';

export const MarketingSiteContext = React.createContext({
  config: {
    showBadge: false,
  },
  pages: { ...INITIAL_LANDING_PAGE_DATA },
});
